import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody, ModalHeader, Button } from "reactstrap";

const ConfirmModal = ({
  isOpen,
  toggle,
  title = "Confirm",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  variant = "primary",
}) => {
  const handleConfirm = () => {
    onConfirm?.();
    toggle();
  };

  const handleCancel = () => {
    onCancel?.();
    toggle();
  };

  const isDanger = variant === "danger";

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleCancel}
      centered
      className="confirm-modal"
      style={{ borderRadius: "12px", overflow: "hidden" }}
    >
      <ModalHeader
        toggle={handleCancel}
        className="border-0 pb-0"
        style={{ fontWeight: 600, fontSize: "1.25rem" }}
      >
        {title}
      </ModalHeader>
      <ModalBody className="pt-2 pb-4">
        <div
          className="d-flex align-items-start mb-4"
          style={{ gap: "1rem" }}
        >
          <div
            className="d-flex align-items-center justify-content-center flex-shrink-0 rounded-circle"
            style={{
              width: 48,
              height: 48,
              background: isDanger ? "rgba(220, 53, 69, 0.12)" : "rgba(13, 110, 253, 0.12)",
            }}
          >
            <i
              className={isDanger ? "mdi mdi-alert-circle-outline" : "mdi mdi-help-circle-outline"}
              style={{
                fontSize: "1.75rem",
                color: isDanger ? "#dc3545" : "#0d6efd",
              }}
            />
          </div>
          <p
            className="mb-0 text-muted"
            style={{ fontSize: "0.9375rem", lineHeight: 1.5 }}
          >
            {message}
          </p>
        </div>
        <div className="d-flex justify-content-end gap-2">
          <Button color="light" onClick={handleCancel} className="px-3">
            {cancelLabel}
          </Button>
          <Button
            color={isDanger ? "danger" : "primary"}
            onClick={handleConfirm}
            className="px-3"
          >
            {confirmLabel}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  variant: PropTypes.oneOf(["primary", "danger"]),
};

export default ConfirmModal;
